export default __webpack_public_path__ + "static/media/670.abb70fd3.png";